module.exports = __webpack_public_path__ + "static/img/beans-off.5e79549f.png";